// MetaRow — Ticker / Timeframe / Direction trio inside the publish modal.
import React from "react";
import { ChevronDown, TrendingUp, TrendingDown, Minus } from "lucide-react";
import { Field } from "./Field";

export const TIMEFRAMES = ["1M", "5M", "15M", "30M", "1H", "4H", "1D", "1W", "1MES"];
export const DIRECTIONS = [
  { id: "LONG", label: "LONG ↑", icon: TrendingUp, accent: "#10b981" },
  { id: "SHORT", label: "SHORT ↓", icon: TrendingDown, accent: "#ef4444" },
  { id: "NEUTRAL", label: "NEUTRAL", icon: Minus, accent: "#6b7280" },
];

export const MetaRow = ({
  ticker, setTicker,
  timeframe, setTimeframe,
  direction, setDirection,
  ui,
}) => (
  <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-3">
    <Field label={ui.pam_label_ticker}>
      <input
        value={ticker}
        onChange={(e) => setTicker(e.target.value.toUpperCase().slice(0, 16))}
        placeholder={ui.pam_field_ticker_ph}
        className="w-full rounded-xl border border-white/10 bg-white/[0.04] px-3 py-2.5 text-sm uppercase outline-none focus:border-orange-400/50"
        data-testid="shadow-publish-ticker"
      />
    </Field>
    <Field label={ui.pam_label_timeframe}>
      <div className="relative">
        <select
          value={timeframe}
          onChange={(e) => setTimeframe(e.target.value)}
          className="w-full appearance-none rounded-xl border border-white/10 bg-white/[0.04] px-3 py-2.5 text-sm outline-none focus:border-orange-400/50"
          data-testid="shadow-publish-timeframe"
        >
          <option value="">—</option>
          {TIMEFRAMES.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
        <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-white/40" />
      </div>
    </Field>
    <Field label={ui.pam_field_direction}>
      <div className="flex gap-1.5">
        {DIRECTIONS.map((d) => (
          <button
            key={d.id}
            type="button"
            onClick={() => setDirection(direction === d.id ? "" : d.id)}
            data-testid={`shadow-publish-dir-${d.id}`}
            className="flex flex-1 items-center justify-center gap-1 rounded-xl border px-1 py-2 text-[10px] font-black uppercase tracking-wider transition-all"
            style={{
              borderColor: direction === d.id ? d.accent : "rgba(255,255,255,0.1)",
              background: direction === d.id ? `${d.accent}1f` : "rgba(255,255,255,0.02)",
              color: direction === d.id ? d.accent : "rgba(255,255,255,0.55)",
            }}
          >
            <d.icon className="h-3 w-3" />
            {d.id}
          </button>
        ))}
      </div>
    </Field>
  </div>
);

export default MetaRow;
